import * as React from 'react';
import {connect} from "react-redux";
import Login from "../components/Login";
import {isOnline, loginAdmin} from "../actions/userActions";
import {translate} from "react-i18next";
import { Container} from 'semantic-ui-react';
import ErrorController from "./ErrorController";
import IndexController from "./IndexController";
import {isProcessing} from "../actions/processingActions";
import {PROC_LOGIN} from "../actions";
import SnackbarController from "./SnackbarController";


class App extends React.Component {
	componentDidMount() {
		const {onLoad} = this.props;
		onLoad && onLoad();
	}
	
	render = () => {
		const {user, onLogin, logingIn} = this.props;
		return (
				<Container fluid={true}>
						{user ? <IndexController /> : <Login processing={logingIn} onLogin={onLogin} grouped={true}/>}
					<ErrorController />
					{/*<Loader active={isLoading} duration={400}/>*/}
					<SnackbarController />
				</Container>
		);
	};
}

const m2s = (state) => ({
	user: state.user.data,
	isLoading: state.loader > 0,
	logingIn: isProcessing(state, PROC_LOGIN)
});

const m2d = (dispatch) => ({
	onLoad: () => {
		dispatch(isOnline(() => {
			// to what is needed...
		}));
	},
	onLogin: (data, onSuccess) => dispatch(loginAdmin(data, onSuccess))
});
App = translate()(App);
export default connect(m2s, m2d)(App);


// WEBPACK FOOTER //
// ./src/containers/AppController.js